import dayjs, {Dayjs} from 'dayjs'

import {FreeTimeException, TestingWeekRule} from '@/src/features/functional-testing/core/dto'

export const getAllowedDaysOfWeek = (weekRules: TestingWeekRule[]): TestingWeekRule['day_of_week'][] => {
  return weekRules.map(weekRule => weekRule.day_of_week)
}

export const allowDayOfWeek = (
  date: Dayjs,
  weekRules: TestingWeekRule[],
  timeOffsetInHours: number,
  exceptions: FreeTimeException[] = [],
): boolean => {
  const dateNative = date.toDate()

  const dayOfWeek = getDayOfWeek(dateNative)

  const exceptionsWithConvertedDayjs = exceptions.map(exception => ({...exception, date: dayjs(exception.date)}))

  const sameDateException = exceptionsWithConvertedDayjs.find(exception => exception.date.isSame(dateNative))

  if (sameDateException) {
    return sameDateException.type === 'open'
  }

  if (weekRules.length === 0) {
    return false
  }

  const rule = weekRules.find(r => r.day_of_week === dayOfWeek)
  if (!rule) {
    return false
  }

  const ruleMaxDate = new Date(dateNative.getFullYear(), dateNative.getMonth(), dateNative.getDate(), rule.to_hour)

  return dateNative <= ruleMaxDate
}

export const allowDay = (
  date: Dayjs,
  weekRules: TestingWeekRule[],
  timeOffsetInHours: number,
  exceptions: FreeTimeException[] = [],
) => {
  const exceptionsWithConvertedDayjs = exceptions.map(exception => ({...exception, date: dayjs(exception.date)}))

  const exception = exceptionsWithConvertedDayjs.find(exception =>
    exception.date.startOf('day').isSame(date.startOf('day')),
  )

  if (exception) {
    return exception.type === 'open'
  }

  if (date.startOf('day').toDate() < getDateWithOffset(dayjs(new Date()).startOf('day').toDate(), timeOffsetInHours)) {
    return false
  }

  return true
}

export const getDateWithOffset = (now: Date, offsetHours: number) => {
  if (now.getTimezoneOffset() / 60 == -offsetHours) {
    offsetHours = 0
  } else {
    now = new Date(now.getTime() - -now.getTimezoneOffset() * 60 * 1000)
  }
  return new Date(now.getTime() + offsetHours * 60 * 60 * 1000)
}

// TODO: вынести в shared/utils
const getDayOfWeek = (date: Date) => date.getDay() || 7
